import React from "react";
import { use100vh } from "react-div-100vh";
import Post from "./Post";
import PostOverlay from "./PostOverlay";

export default function PostContainer({ post, showOverlay }) {
  const height = use100vh();
  return (
    <div
      className="overflow-hidden flex relative justify-center w-full lg:w-2/3 bg-[#303030]"
      style={{ maxHeight: height }}
    >
      <PostOverlay post={post} visible={showOverlay} />
      <Post post={post} />
    </div>
  );
}
